import React, { Component, useState } from 'react';
import { priceFormat, statusFormat, bedsFormat, comma } from '../common/HelperFunctions';
import InterestModal from '../developments/InterestModal';

export default class DevelopmentHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    this.setState({ mobile: window.innerWidth < 768 });
  }

  render() {
    const { properties } = this.props;
    let customPrice = '';
    if (properties && properties.length) {
      const reserved = properties.filter((p) => p.status === 'reserved');
      const sold = properties.filter((p) => p.status === 'sold');
      if (properties.length === reserved.length + sold.length) {
        customPrice = reserved.length ? 'RESERVED' : 'SOLD';
      }
    }
    const price =
      customPrice ||
      (this.props.status && this.props.status !== 'available'
        ? statusFormat(this.props.status)
        : priceFormat(this.props.min_price || this.props.price, this.props.max_price));
    const coverImage = this.props.thumbnail
      ? `/uploads/developments/${this.props.development}/header.jpg`
      : '/images/development.jpg';

    return (
      <section className="header title">
        <div
          className="header-image"
          style={{
            backgroundImage: `url(${coverImage})`,
          }}
        />
        <div className="content">
          <div className="container">
            <div className="col-ms-6 col-md-3">
              <h3 className="name">{this.props.name}</h3>
              <h4 className="location">{comma(this.props.town, this.props.county)}</h4>
              <h3 className="price">{price}</h3>
              <p className="address">
                {comma(this.props.street, this.props.town, this.props.county)}{' '}
                <span style={{ whiteSpace: 'nowrap' }}>{this.props.postcode}</span>
              </p>
            </div>
            <IconSection {...this.props} end={false} />
            <div className="col-xs-12 col-md-6">
              <p style={{ whiteSpace: 'pre-wrap' }}>{this.props.description}</p>
              <ul style={{ paddingLeft: 15 }}>
                {this.props.bullets &&
                  this.props.bullets.map((bullet, i) => <li key={i}>{bullet}</li>)}
              </ul>
            </div>
            <IconSection {...this.props} end customPrice={customPrice} />
          </div>
        </div>
      </section>
    );
  }
}

function IconSection(props) {
  const beds = props.min_beds || props.beds || props.bedrooms;
  const active =
    props.customPrice !== 'SOLD' &&
    props.status !== 'portfolio' &&
    props.development_status !== 'portfolio';

  const [interestModalOpen, setInterestModalOpen] = useState(false);
  return (
    <div
      className={`col-ms-6 col-md-3 ${
        props.end ? ' visible-md visible-lg' : ' visible-xs visible-sm visible-ms'
      }`}
    >
      <InterestModal
        open={interestModalOpen}
        onClose={() => setInterestModalOpen(false)}
        development={props.name}
        developmentId={props.id}
      />
      <table className="table table-icon">
        <tbody>
          <tr>
            <td>
              <span className="icon-2x icon-bed" aria-hidden="true" />
            </td>
            <td>{bedsFormat(beds, props.max_beds)}</td>
          </tr>
          {props.brochure && (
            <tr>
              <td>
                <a
                  href={`/uploads/developments/${props.development}/brochure.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="icon-2x icon-book" aria-hidden="true" />
                </a>
              </td>
              <td>
                <a
                  href={`/uploads/developments/${props.development}/brochure.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'underline' }}
                >
                  Sales Brochure
                </a>
              </td>
            </tr>
          )}
          {props.virtual_tour && (
            <tr>
              <td>
                <a href={props.virtual_tour} target="_blank" rel="noopener noreferrer nofollow">
                  <span className="icon-2x icon-360" aria-hidden="true" />
                </a>
              </td>
              <td>
                <a
                  href={props.virtual_tour}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  style={{ textDecoration: 'underline' }}
                >
                  Virtual Tour
                </a>
              </td>
            </tr>
          )}
          {active && (
            <tr>
              <td>
                <a href="#" onClick={() => setInterestModalOpen(true)}>
                  <span className="icon-2x icon-envelope" aria-hidden="true" />
                </a>
              </td>
              <td>
                <a
                  href="#"
                  onClick={() => setInterestModalOpen(true)}
                  style={{ textDecoration: 'underline' }}
                >
                  Register Interest
                </a>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
